import React from "react";
import { IconContainer } from "../IconContainer";

export const TableBlockIcon = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.38672C3 4.72986 4.34315 3.38672 6 3.38672H8.25C9.90685 3.38672 11.25 4.72986 11.25 6.38672V8.63672C11.25 10.2936 9.90685 11.6367 8.25 11.6367H6C4.34315 11.6367 3 10.2936 3 8.63672V6.38672ZM12.75 6.38672C12.75 4.72986 14.0931 3.38672 15.75 3.38672H18C19.6569 3.38672 21 4.72986 21 6.38672V8.63672C21 10.2936 19.6569 11.6367 18 11.6367H15.75C14.0931 11.6367 12.75 10.2936 12.75 8.63672V6.38672ZM3 16.1367C3 14.4799 4.34315 13.1367 6 13.1367H8.25C9.90685 13.1367 11.25 14.4799 11.25 16.1367V18.3867C11.25 20.0436 9.90685 21.3867 8.25 21.3867H6C4.34315 21.3867 3 20.0436 3 18.3867V16.1367ZM12.75 16.1367C12.75 14.4799 14.0931 13.1367 15.75 13.1367H18C19.6569 13.1367 21 14.4799 21 16.1367V18.3867C21 20.0436 19.6569 21.3867 18 21.3867H15.75C14.0931 21.3867 12.75 20.0436 12.75 18.3867V16.1367Z"
      fill="currentColor"
    />
  </IconContainer>
);
